import { Navigate, Route, Routes } from "react-router-dom";

import RiderPortalGuard from "./components/RiderPortalGuard";
import RiderLayout from "./layout/RiderLayout";
import RiderHome from "./pages/RiderHome";
import RiderAssignments from "./pages/RiderAssignments";
import RiderActiveRun from "./pages/RiderActiveRun";
import RiderHistory from "./pages/RiderHistory";

export default function RiderRoutes() {
  return (
    <Routes>
      <Route element={<RiderPortalGuard />}>
        <Route element={<RiderLayout />}>
          <Route index element={<RiderHome />} />
          <Route path="today" element={<RiderHome />} />
          <Route path="assignments" element={<RiderAssignments />} />
          <Route path="run" element={<RiderActiveRun />} />
          <Route path="history" element={<RiderHistory />} />
          <Route path="*" element={<Navigate to="/rider" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
